import Session from "./session";

class Payment  {
	constructor(request) {
		this.request = request
		this.endpoint = 'payment'
	}

	async Submit(info) {
		let jwtToken = await Session.GetJWTToken();
		return this.request.send(
			`${this.endpoint}/webform/submit`,
			'POST',
			info,
			jwtToken,
			undefined,
			{
				"configkey":"618f4670ee72f6e9f11c42fdcc1c3da6"
			}
		)
	}

	async RequestCreditCard(info) {
		let jwtToken = await Session.GetJWTToken();
		return this.request.send(
			`${this.endpoint}/creditcard/hitpay`,
			'POST',
			info,
			jwtToken,
			undefined,
			{
			}
		)
	}


	async RequestQR(info) {
		let jwtToken = await Session.GetJWTToken();
		return this.request.send(
			`${this.endpoint}/qrph/hitpay`,
			'POST',
			info,
			jwtToken,
			undefined,
			{
			}
		)
	}

	async QRStatus(requestid) {
		let jwtToken = await Session.GetJWTToken();
		return this.request.send(
			`${this.endpoint}/status/hitpay`,
			'POST',
			{requestid},
			jwtToken,
			undefined,
			{
			}
		)
	}

	async GetHistory(username, type="payment", statusFilter="", pageOffset=0) {
		let jwtToken = await Session.GetJWTToken();
		const body = {
			username:username,
			statusfilter:statusFilter,
			pageoffset:pageOffset,
			type:type
		};
		return this.request.send(
			`${this.endpoint}/list`,
			'POST',
			body,
			jwtToken
		)
	}

	// Logic of API, use seller if available, fallback to groupid if none
	async GetPaymentOptions(seller = "", groupId) {
		let jwtToken = await Session.GetJWTToken();

		const body = {
			seller: seller,
			groupid: groupId
		}

		return this.request.send(
			`${this.endpoint}/options/get`,
			'POST',
			body,
			jwtToken
		)
	}

}

export default Payment
